export { default as ProductUpsell } from './product-upsell';
